import moment from 'moment-timezone';
import { timeZoneMap } from '../CommonComponent/staticValues';

export const formatDateForLists = (timestamp, time_zone, overview=false) => {
    if (timestamp === '' || !timestamp) {
        return '-';
    }
    const hasMappedTimeZone = Object.prototype.hasOwnProperty.call(timeZoneMap, time_zone);
    let resolvedTimeZone = hasMappedTimeZone ? timeZoneMap[time_zone] : (time_zone || 'Etc/GMT');
        
    const tz = moment.tz(timestamp, resolvedTimeZone);
    const formatted = tz.format("DD MMM YYYY / HH:mm");
    const abbr = tz.zoneAbbr();
    return `${formatted} ${abbr} ${overview ? '(UTC'+tz.format("Z")+')' : ''}`;
        
};